module.exports = __webpack_public_path__ + "img/unit-card-status-discharging.648bb604.png";